import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ChatWidget } from '../components/chat-widget/chat-widget';
import { Header } from '../components/header/header';

@Component({
  selector: 'app-full-layout',
  imports: [RouterOutlet, Header, ChatWidget],
  templateUrl: './full-layout.html',
  styleUrl: './full-layout.scss'
})
export class FullLayout {}
